
export interface Platform {
  id: string;
  name: string;
  logo: string;
}

// Mapeamento entre slugs do frontend e nomes da API
export const platformSlugToApiName: Record<string, string> = {
  'payt': 'payt',
  'hotmart': 'hotmart',
  'braip': 'braip',
  'monetizze': 'monetizze',
  'perfectpay': 'perfect_pay',
  'cartpanda': 'cartpanda',
  'kirvano': 'kirvano',
  'kiwify': 'kiwify',
  'ticto': 'ticto',
  'vegacheckout': 'vega_checkout',
  'eduzz': 'eduzz',
  'cakto': 'cakto',
  'guru': 'digital_manager_guru',
};

export const platformsData: Platform[] = [
  { id: 'payt', name: 'Payt', logo: '/assets/companies/payt.svg' },
  {
    id: 'hotmart',
    name: 'Hotmart',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a5/Logo_hotmart.png',
  },
  {
    id: 'braip',
    name: 'Braip',
    logo: 'https://ev.braip.com/img/logo-braip.svg',
  },
  {
    id: 'monetizze',
    name: 'Monetizze',
    logo: 'https://app.hostvsl.com.br/assets/monetizze-BLdBtItv.png',
  },
  {
    id: 'perfectpay',
    name: 'PerfectPay',
    logo: 'https://app.hostvsl.com.br/assets/perfectPay-BKStvkgb.png',
  },
  {
    id: 'cartpanda',
    name: 'Cartpanda',
    logo: 'https://reportana.com/themes/reportana/assets/img/integrations/cartpanda-logo.svg',
  },
  {
    id: 'kirvano',
    name: 'Kirvano',
    logo: 'https://reportana.com/themes/reportana/assets/img/integrations/kirvano-logo.svg',
  },
  {
    id: 'kiwify',
    name: 'Kiwify',
    logo: 'https://reportana.com/themes/reportana/assets/img/integrations/kiwify-logo.svg',
  },
  {
    id: 'ticto',
    name: 'Ticto',
    logo: 'https://reportana.com/themes/reportana/assets/img/integrations/ticto-logo.svg',
  },
  {
    id: 'vegacheckout',
    name: 'Vega Checkout',
    logo: 'https://app.hostvsl.com.br/assets/vegaCheckout-bmUSrXpX.svg',
  },
  {
    id: 'eduzz',
    name: 'Eduzz',
    logo: 'https://cdn.prod.website-files.com/64e64b6388ada1cf4f0fe874/64e64b6388ada1cf4f0fe88c_logo-eduzz.png',
  },
  {
    id: 'cakto',
    name: 'Cakto',
    logo: 'https://app.cakto.com.br/logo/green-text-logo-transparent-background-login.png',
  },
  {
    id: 'guru',
    name: 'Digital Manager Guru',
    logo: '/assets/companies/logo-guru-roxo.svg',
  },
];
